import PropTypes from 'prop-types';
import React from 'react';
import './StripeButton.css';

const StripeButton = ({
  variant = 'primary',
  size = 'md',
  icon,
  iconPosition = 'left',
  iconOnly = false,
  children,
  fullWidth = false,
  loading = false,
  disabled = false,
  className = '',
  ...props
}) => {
  const classNames = [
    'stripe-btn',
    `stripe-btn-${variant}`,
    `stripe-btn-${size}`,
    fullWidth && 'stripe-btn-full-width',
    loading && 'stripe-btn-loading',
    iconOnly && 'stripe-btn-icon-only',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  const buttonType = props.type || 'button';

  return (
    <button type={buttonType} className={classNames} disabled={disabled || loading} {...props}>
      {loading ? (
        <>
          <span className="stripe-btn-spinner" />
          <span>Loading...</span>
        </>
      ) : (
        <>
          {iconOnly ? (
            <span className="stripe-btn-icon">{icon}</span>
          ) : (
            <>
              {icon && iconPosition === 'left' && (
                <span className="stripe-btn-icon stripe-btn-icon-left">{icon}</span>
              )}
              {children}
              {icon && iconPosition === 'right' && (
                <span className="stripe-btn-icon stripe-btn-icon-right">{icon}</span>
              )}
            </>
          )}
        </>
      )}
    </button>
  );
};

StripeButton.propTypes = {
  variant: PropTypes.oneOf(['primary', 'secondary', 'ghost', 'text', 'danger']),
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  icon: PropTypes.node,
  iconPosition: PropTypes.oneOf(['left', 'right']),
  iconOnly: PropTypes.bool,
  children: PropTypes.node,
  fullWidth: PropTypes.bool,
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
  className: PropTypes.string,
};

export default StripeButton;

